import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'material-ui/Tooltip';
import {withStyles} from 'material-ui/styles';
import Info from 'material-ui-icons/InfoOutline';
import {
    TableCell,
    TableRow,
} from 'material-ui/Table';


const styles = theme => ({
    tableCell: {
        width: 50,
        padding: '0px !important',
        fontSize: '14px',
    },
    tableCellDate: {
        width: 80,
        padding: '0px !important',
        fontSize: '14px',
    },
    activeSortLabel: {
        color: 'white !important',
    },
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        backgroundColor: '#f5f5f5'
    },
    table: {
        minWidth: 800
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    paginationColor: '#ffffff',
    tableRoot: {},
    filterTitle: {
        fontSize: '15px',
        margin: '0 0 0 10px'
    },
    filterTitleMonth: {
        fontSize: '15px',
        // margin: '0 0 0 10px',
        [theme.breakpoints.up('lg')]: {
            float: 'right',
            paddingRight: '10px',
        },
        [theme.breakpoints.down('md')]: {
            paddingLeft: '10px',
        }
    },
    moreFilters: {
        // fontSize: '15px',
        // margin: '0 0 0 10px',
        cursor: 'pointer'
    },
    fontSizeDefault: {
        fontSize: '15px',
        // border: '1px solid #beb7b7 ',
        backgroundColor: 'white',
        color: 'black',
        borderRadius: '3px',
        padding: '5px',
        // marginBottom: '15px'
    },
    fontSizeTime: {
        fontSize: '12px',
        marginTop: '6px',
        marginRight: '16px',
        marginBottom: '0px'
    },
    fontSizeCells: {
        fontSize: '14px',
        padding: 12
        // paddingRight: '0px',
        // paddingLeft: '0px'
    },
    fontSizeIcons: {
        color: 'rgb(117, 117, 117)',
        cursor: 'pointer'
    },
    fontSizeHeadersList: {
        fontSize: '13px',
        lineHeight: '14px',
        fontWeight: '500'
    },
    fontSizeHeadersListCategory: {
        fontSize: '13px',
        lineHeight: '14px',
        [theme.breakpoints.up('lg')]: {
            paddingLeft: '12px',
            paddingRight: '0px'
        },
        fontWeight: '500'
    },
    tooltipComment: {
        fontSize: '13px',
        // maxWidth: '335px'
    },
    primaryListItem: {
        fontSize: '11px !important',
    },
    fontSizeIconsFilter: {
        width: '20px',
        height: '20px'
    },
    gridList: {
        [theme.breakpoints.up('md')]: {
            padding: '0'
        }
    },
    filterRow: {
        width: '100%',
        display: 'inline-flex',
        right: '0px',
        float: 'left',
        marginTop: '10px',
        [theme.breakpoints.up('lg')]: {
            float: 'right',
        }
    },
    filterRowAccount: {
        width: '100%',
        display: 'inline-flex',
        right: '0px',
        float: 'left',
        marginTop: '10px',
        [theme.breakpoints.up('lg')]: {
            float: 'right',
            marginRight: '40px'
        },
    },
    selectFilter: {
        [theme.breakpoints.down('md')]: {
            paddingRight: '20px'
        },
    },
    filterButton: {
        float: 'right',
        margin: '20px 10px 5px 10px'
    },
    modal: {
        position: 'absolute',
        border: '1px solid #e5e5e5',
        backgroundColor: '#fff',
        boxShadow: '0 5px 15px rgba(0, 0, 0, .5)',
        padding: '20px',
        [theme.breakpoints.down('xs')]: {
            top: '1%',
            left: '10%',
            height: '95%',
            width: '80%',
            overflowY: 'scroll',
        },
        [theme.breakpoints.up('sm')]: {
            top: '5%',
            left: '20%',
            height: '90%',
            width: '60%',
            overflowY: 'scroll',
        },
        [theme.breakpoints.up('md')]: {
            top: '10%',
            left: '10%',
            height: '570px',
            width: '80%',
            overflowY: 'none',
        },
        [theme.breakpoints.up('lg')]: {
            top: '5%',
            left: '15%',
            height: '570px',
            width: '70%',
            overflowY: 'none',
        },
    },
    modalTransfer: {
        position: 'absolute',
        border: '1px solid #e5e5e5',
        backgroundColor: '#fff',
        boxShadow: '0 5px 15px rgba(0, 0, 0, .5)',
        padding: '20px',
        [theme.breakpoints.down('xs')]: {
            top: '1%',
            left: '10%',
            height: '85%',
            width: '80%',
            overflowY: 'scroll',
        },
        [theme.breakpoints.up('sm')]: {
            top: '5%',
            left: '20%',
            height: '70%',
            width: '60%',
            overflowY: 'scroll',
        },
        [theme.breakpoints.up('md')]: {
            top: '10%',
            left: '10%',
            height: '570px',
            width: '80%',
            overflowY: 'none',
        },
        [theme.breakpoints.up('lg')]: {
            top: '5%',
            left: '15%',
            height: '570px',
            width: '70%',
            overflowY: 'none',
        },
    },
    loader: {
        [theme.breakpoints.up('md')]: {
            /*left: '-220px'*/
        },
        width: '150px',
        height: '150px',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        margin: 'auto'
    },
    svgDeterminate: {
        animation: 'mui-progress-circular-rotate 1.4s linear infinite',
        transform: 'rotate(0deg)',
        // position: 'absolute',
        width: '150px',
        // marginLeft: '5%',
        // marginTop: '30px',
        // [theme.breakpoints.up('sm')]: {
        //     left: '50%',
        // },
        // [theme.breakpoints.down('sm')]: {
        //     left: '35%',
        // },
        // [theme.breakpoints.down('xs')]: {
        //     left: '25%',
        // },
        // transform: 'translate(-50%, -50%)',
    },
    svgDeterminateCell: {
        animation: 'mui-progress-circular-rotate 1.4s linear infinite',
        transform: 'rotate(0deg)',
        // position: 'absolute',
        width: '30px',
        // marginLeft: '5%',
        // marginTop: '30px',
        // [theme.breakpoints.up('sm')]: {
        //     left: '50%',
        // },
        // [theme.breakpoints.down('sm')]: {
        //     left: '35%',
        // },
        // [theme.breakpoints.down('xs')]: {
        //     left: '25%',
        // },
        // transform: 'translate(-50%, -50%)',
    },
    rootCircularProgress: {
        width: 'auto !important',
        height: 'auto !important'
    },
    mobileHeaders: {
        fontSize: '16px'
    },
    mobileListItem: {
        fontSize: '15px',
        fontWeight: '410',
        marginLeft: '30px',
        // [theme.breakpoints.down('xs')]: {
        //     marginLeft: '15px',
        // },
    },
    mobileListItemValue: {
        fontSize: '15px',
        marginRight: '10px'
    },
    mobileHeaderSum: {
        fontSize: '16px',
        fontWeight: '500'
    },
    gridContainerMobile: {
        marginBottom: '15px'
    },
    accountValue: {
        paddingTop: '5px',
        fontSize: '12px',
        marginBottom: '0px'
    },
    accountName: {
        marginBottom: '0px',
        marginTop: '17px'
    },
    fontSizeDate: {
        marginBottom: '0px',
        marginTop: '16px'
    },
    listItemMobile: {
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '10px',
            paddingRight: '10px'
        },
    },
    iconMobile: {
        [theme.breakpoints.down('xs')]: {
            marginRight: '0px'
        },
    },
    incomeIcon: {
        color: 'rgb(102, 187, 106)'
    },
    consumptionIcon: {
        color: 'rgb(239, 154, 154)'
    },
    incomeIconMobile: {
        color: 'rgb(102, 187, 106)',
        [theme.breakpoints.down('xs')]: {
            marginRight: '0px'
        },
    },
    consumptionIconMobile: {
        color: 'rgb(239, 154, 154)',
        [theme.breakpoints.down('xs')]: {
            marginRight: '0px'
        },
    },
    incomeSum: {
        color: 'rgb(102, 187, 106)',
        fontWeight: 500,
        fontSize: '14px',
        paddingRight: '0px',
        paddingLeft: '0px'
    },
    consumptionSum: {
        color: '#ff0000',
        fontSize: '14px',
        paddingRight: '0px',
        paddingLeft: '0px'
    },
    incomeSumMobile: {
        color: 'rgb(102, 187, 106)',
        fontWeight: 500,
        fontSize: '15px',
    },
    consumptionSumMobile: {
        color: '#ff0000',
        fontSize: '15px',
    },
    captionTablePagination: {
        fontSize: 14,
        paddingBottom: 0
    },
    selectTablePagination: {
        paddingRight: 25,
        paddingBottom: 0
    },
    selectIconTablePagination: {
        paddingBottom: 4
    },
    actionsTablePagination: {
        paddingBottom: 10,
        marginBottom: 10
    },
    selectItem: {
        fontSize: 16
    },
    selectItemCounterparty: {
        [theme.breakpoints.down('md')]: {
            margin: '0px 10px'
        },
        fontSize: 16
    }

});

class UsersRow extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.getDate = this.getDate.bind(this);
        this.openCompaniesTable = this.openCompaniesTable.bind(this);

        this.handleTooltipClick = this.handleTooltipClick.bind(this);
        this.handleTooltipLeadIdClick = this.handleTooltipLeadIdClick.bind(this);

        this.state = {
            openTooltip: false,
            openTooltipLeadId: false
        };
    }

    getDate(date) {
        let dateFormat = new Date(date.split('T')[0]);
        let month = (dateFormat.getMonth() + 1 < 10) ? ("0" + (dateFormat.getMonth() + 1)) : (dateFormat.getMonth() + 1);
        let day = (dateFormat.getDate() < 10) ? ("0" + dateFormat.getDate()) : dateFormat.getDate();
        let dateStringFormat = day + "." + month + '.' + dateFormat.getFullYear();
        let resultData = {
            date: dateStringFormat,
            time: (date.split('T')[1]).split('.')[0]
        };
        return resultData;
    }

    openCompaniesTable = company => () => {
        window.open(`https://kamino.app.finmap.online/companies/${company._id}`);

        // window.open(`http://localhost:3000/companies/${company._id}`);
        console.log('open company', company);
    };

    handleTooltipClick() {
        const _this = this;
        _this.setState({
            openTooltip: !_this.state.openTooltip
        });
    }

    handleTooltipLeadIdClick() {
        const _this = this;
        _this.setState({
            openTooltipLeadId: !_this.state.openTooltipLeadId
        });
    }

    render() {
        const _this = this;
        const {classes} = this.props;
        let reg_date = _this.getDate(_this.props.user.creation_date);
        let last_login_date = _this.props.user.last_login_date ? _this.getDate(_this.props.user.last_login_date) : {
            date: '',
            time: ''
        };
        return (
            <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={_this.props.user._id}
                id={_this.props.user._id}
                style={_this.props.user_link === _this.props.user._id ? {backgroundColor: '#cccccc80'} : null}
            >
                <TableCell className={classes.tableCell}
                           numeric>
                    {_this.props.user.index}
                </TableCell>
                <TableCell className={classes.tableCell}
                           numeric>
                    <Tooltip
                        title={_this.props.user._id}
                        placement={'right'}
                        enterDelay={300}
                        classes={{tooltip: classes.tooltipComment}}
                        disableTriggerFocus={true}
                        disableTriggerHover={true}
                        disableTriggerTouch={true}
                        open={_this.state.openTooltip}
                    >
                        <Info style={{cursor: 'pointer'}}
                              onClick={() => {
                                  _this.handleTooltipClick();
                              }}
                        />
                    </Tooltip>
                </TableCell>
                <TableCell className={classes.tableCellDate}
                           numeric>
                    <p className={classes.fontSizeDate}>{reg_date.date}</p>
                    <p className={classes.fontSizeTime}>{reg_date.time}</p>
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    {_this.props.user.email && _this.props.user.email.length > 20 ?
                        <Tooltip
                            title={_this.props.user.email}
                            placement={'top'}
                            enterDelay={300}
                            classes={{tooltip: classes.tooltipComment}}
                        >
                            <div
                                style={{cursor: 'pointer'}}>{_this.props.user.email.slice(0, 20)}..
                            </div>
                        </Tooltip> :
                        _this.props.user.email
                    }
                </TableCell>
                <TableCell className={classes.tableCellDate}
                           numeric>
                    <p className={classes.fontSizeDate}>{last_login_date.date}</p>
                    <p className={classes.fontSizeTime}>{last_login_date.time}</p>
                </TableCell>
                <TableCell className={classes.tableCell}
                           numeric>
                    {_this.props.user.login_seven_days}
                </TableCell>
                <TableCell className={classes.tableCell}
                           numeric>
                    {_this.props.user.login_fourteen_days}
                </TableCell>
                <TableCell className={classes.tableCell}
                           numeric>
                    {_this.props.user.login_thirty_days}
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    {_this.props.user.name}
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    {_this.props.user.phone}
                </TableCell>
                {( _this.props.user.user_companies.length) ?
                    <TableCell className={classes.fontSizeCells}
                               padding='none'
                               numeric>
                        {_this.props.user.user_companies.map((company) => {
                            return (
                                <div key={company._id}
                                     // onClick={_this.openCompaniesTable(company)}
                                     style={{
                                         marginTop: '5px',
                                         marginBottom: '5px',
                                         // cursor: 'pointer'
                                     }}>
                                    {company.name}
                                </div>
                            );
                        })}
                    </TableCell> :
                    <TableCell className={classes.fontSizeCells}
                               padding='none'/>
                }
                <TableCell className={classes.tableCell}
                           numeric>
                    {_this.props.user.employees}
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    {_this.props.user.lead_id ?
                        <Tooltip
                            title={_this.props.user.lead_id}
                            placement={'right'}
                            enterDelay={300}
                            classes={{tooltip: classes.tooltipComment}}
                            disableTriggerFocus={true}
                            disableTriggerHover={true}
                            disableTriggerTouch={true}
                            open={_this.state.openTooltipLeadId}
                        >
                            <Info style={{cursor: 'pointer'}}
                                  onClick={() => {
                                      _this.handleTooltipLeadIdClick();
                                  }}
                            />
                        </Tooltip>
                    : ''}
                </TableCell>
                {/*<TableCell className={classes.fontSizeCells}*/}
                           {/*numeric>*/}
                    {/*{_this.props.user.lead_form && _this.props.user.lead_form.length > 20 ?*/}
                        {/*<Tooltip*/}
                            {/*title={_this.props.user.lead_form}*/}
                            {/*placement={'top'}*/}
                            {/*enterDelay={300}*/}
                            {/*classes={{tooltip: classes.tooltipComment}}*/}
                        {/*>*/}
                            {/*<div*/}
                                {/*style={{cursor: 'pointer'}}>{_this.props.user.lead_form.slice(0, 20)}..*/}
                            {/*</div>*/}
                        {/*</Tooltip> :*/}
                        {/*_this.props.user.lead_form*/}
                    {/*}*/}
                {/*</TableCell>*/}
                {/*<TableCell className={classes.fontSizeCells}*/}
                           {/*numeric>*/}
                    {/*{_this.props.user.lead_url && _this.props.user.lead_url.length > 20 ?*/}
                        {/*<Tooltip*/}
                            {/*title={_this.props.user.lead_url}*/}
                            {/*placement={'top'}*/}
                            {/*enterDelay={300}*/}
                            {/*classes={{tooltip: classes.tooltipComment}}*/}
                        {/*>*/}
                            {/*<div*/}
                                {/*style={{cursor: 'pointer'}}>{_this.props.user.lead_url.slice(0, 20)}..*/}
                            {/*</div>*/}
                        {/*</Tooltip> :*/}
                        {/*_this.props.user.lead_url*/}
                    {/*}*/}
                {/*</TableCell>*/}
            </TableRow>
        );
    }
}

UsersRow.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UsersRow);



// WEBPACK FOOTER //
// ./src/components/tabs/users/UsersRow.js